import { useEffect, type ReactNode } from "react";
import { applySacristyTheme } from "../lib/theme";

// Route-scoped boundary that tags the document with Sacristy AI's
// own visual identity (parchment + gold + Playfair). Wraps every
// authenticated scheduler surface so /, /settings, modals, etc.
// wear the Sacristy brand regardless of which parish the signed-in
// user belongs to. Idempotent and cheap to mount.
//
// Pairs with <ParishTheme>, which the public help center uses to
// apply each parish's own branding.
export default function SacristyTheme({ children }: { children: ReactNode }) {
  useEffect(() => {
    applySacristyTheme();
  }, []);
  return <>{children}</>;
}
